<div class="ui top attached button" routerLink="/home">Home</div>
<div class="ui grid">
	<div class="four wide column">
		<app-dice-area [chronicleId]="chronicleId" [char]="char" [isGameMaster]="isGameMaster"></app-dice-area>
	</div>
	<div class="twelve wide column">
		<app-chat [chronicleId]="chronicleId"></app-chat>
	</div>
</div>
